import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import { VDateInput } from 'vuetify/labs/VDateInput'

import theme from './theme'
import defaults from './defaults'

import 'vuetify/styles'
import '@assets/scss/main.scss'

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  components: {
    ...components,
    VFileUpload,
    VDateInput
  },
  directives,
  theme,
  defaults
})

export default vuetify
